import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { initAnalytics } from './analytics'
import { resolveFlavor } from './catalogue'
import { checkForShellUpdate } from './ota/updater'
import { initOta } from './ota/boot'
import { setAssetBase, getAssetBase } from '@syqel/worlds-three'
import { setCostSurface } from './worldCost'

// serve the heavy 3D assets (models/env/scenes) from a CDN when VITE_ASSET_BASE is set at build time;
// empty (default) keeps them same-origin/bundled, so nothing changes until the CDN is wired. A runtime
// global (__SYQEL_ASSET_BASE__) already picked up by worlds-three takes precedence.
if (!getAssetBase()) setAssetBase(import.meta.env.VITE_ASSET_BASE ?? '')
initAnalytics()
void resolveFlavor() // resolve standalone vs Mac App Store early so the UI branches correctly
void checkForShellUpdate() // self-update the desktop shell when in Tauri; no-op on web / App Store

const root = document.getElementById('root')
if (!root) throw new Error('#root not found')
// OTA before first render: the engine-core swap + cached world packages must land before anything
// reads Engine.* or the catalogue. initOta is LOCAL ONLY (activates what is already cached) and never
// throws; the client checks the registry after first paint and stages updates for the next launch
// (render-first boot — ota/boot.ts).
void initOta().finally(() => {
  setCostSurface('desktop') // the Visualizer's smoothness bar + remembered verdicts, before any list is built
  createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
})
